import createTransition from 'shared-tokens/utils/createTransition';
import createBreakpoint from 'shared-tokens/utils/breakpoints';

import { mainCls as cardCls } from '../../style';

const brTablet = createBreakpoint('s');

export const mainCls =  `${cardCls}__tooltip`;

export default {
  [mainCls]: {
    display: 'none',
    '@media (pointer:coarse)': {
      display: 'none !important',
    },
    [brTablet]: {
      display: 'block',
      position: 'absolute',
      left: '50%',
      transform: 'translate3d(-50%, 0, 0)',
      opacity: 0,
      borderRadius: 4,
      pointerEvents: 'none',
      whiteSpace: 'nowrap',
      transition: createTransition(['opacity']),
      '&.revealed': {
        opacity: 1,
        // animation: 'keyframes-fadeInUp .5s',
      },
      '&.hidden': {
        opacity: 0,
        // animation: 'keyframes-fadeOutDown .5s',
      },
      '&:before': {
        position: 'absolute',
        bottom: '-7px',
        left: '50%',
        marginLeft: '-6px',
        content: '""',
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '7px 6px 0 6px',
        borderColor: '#697684 transparent transparent transparent',
      },
    },
  },
  [`${mainCls}--arrow-right`]: {
    left: '-80px',
    '&:before': {
      bottom: '10px',
      left: '145px',
      borderWidth: '6px 0 6px 7px', 
      borderColor: 'transparent transparent transparent #697684',
    }
  },
  [`${mainCls}__maplist`]: {
    left: 0,
    transform: 'none',
    '&:before': {
      left: 10,
      marginLeft: 0,
    },
  },


  // '@-webkit-keyframes fadeInUp': {
  //   from: {
  //     'opacity': 0,
  //     '-webkit-transform': 'translate3d(-50%, 50%, 0)',
  //     'transform': 'translate3d(-50%, 50%, 0)',
  //   },
  //   to: {
  //     'opacity': 1,
  //     '-webkit-transform': 'translate3d(-50%, 0, 0)',
  //     'transform': 'translate3d(-50%, 0, 0)',
  //   },
  // },

  // '@keyframes fadeInUp': {
  //   from: {
  //     'opacity': 0,
  //     '-webkit-transform': 'translate3d(-50%, 50%, 0)',
  //     'transform': 'translate3d(-50%, 50%, 0)',
  //   },
  //   to: {
  //     'opacity': 1,
  //     '-webkit-transform': 'translate3d(-50%, 0, 0)',
  //     'transform': 'translate3d(-50%, 0, 0)',
  //   },
  // },

  // '@-webkit-keyframes fadeOutDown': {
  //   from: {
  //     opacity: 1,
  //   },
  //   to: {
  //     'opacity': 0,
  //     '-webkit-transform': 'translate3d(-50%, 50%, 0)',
  //     'transform': 'translate3d(-50%, 50%, 0)',
  //   },
  // },

  // '@keyframes fadeOutDown': {
  //   from: {
  //     opacity: 1,
  //   },
  //   to: {
  //     'opacity': 0,
  //     '-webkit-transform': 'translate3d(-50%, 50%, 0)',
  //     'transform': 'translate3d(-50%, 50%, 0)',
  //   },
  // },
};
